import { useState } from "react";
import { useOrderConfirmationWorkspace } from "./order-confirmation/useOrderConfirmationWorkspace";
import { OrderConfirmationView } from "./order-confirmation/OrderConfirmationView";
export default function OrderConfirmationPortal() {
  const [token] = useState(() => new URLSearchParams(location.search).get("token") ?? "");
  const workspace = useOrderConfirmationWorkspace({ token });
  return <OrderConfirmationView {...workspace} />;
}
